import * as types from './actionTypes';

export const joinMeeting = status => {
  return {
    type: types.JOIN_MEETING,
    payload: status,
  };
};

export const setAvatarURL = url => {
  return {
    type: types.SET_AVATAR_URL,
    payload: url,
  };
};

export const setDirectLanding = land => {
  return {
    type: types.SET_DIRECT_LANDING,
    payload: land,
  };
};

export const setReadyToMove = (ready_to_move = false) => {
  return {
    type: types.SET_READY_TO_MOVE,
    payload: ready_to_move,
  };
};

export const setShowConfirmationDialog = show => {
  return {
    type: types.SET_SHOW_LEAVE_CONFIRMATION_MODAL,
    payload: show,
  };
};

export const setCourseLeaveConfigs = configs => {
  return {
    type: types.SET_COURSE_LEAVE_CONFIGS,
    payload: configs,
  };
};

export const setLegacyFlag = legacy => {
  return {
    type: types.SET_LEGACY_FLAG,
    payload: legacy,
  };
};

export const setIsQuikbase = isQuikbase => {
  return {
    type: types.SET_IS_QUIKBASE,
    payload: isQuikbase,
  };
};

export const setShowTrailDemo = showTrialDemo => {
  return {
    type: types.SET_SHOW_TRIAL_DEMO,
    payload: showTrialDemo,
  };
};

export const setShowLVDemo = showLVDemo => {
  return {
    type: types.SET_SHOW_LV_DEMO,
    payload: showLVDemo,
  };
};
